import { render } from "./MarketDetail.vue?vue&type=template&id=30d880dd&scoped=true"
import script from "./MarketDetail.vue?vue&type=script&lang=js"
export * from "./MarketDetail.vue?vue&type=script&lang=js"

import "./MarketDetail.vue?vue&type=style&index=0&id=30d880dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d880dd"]])

export default __exports__